import React, { useState } from "react";
import {
  List,
  useTable,
  EditButton,
  DeleteButton,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
} from "@pankod/refine-antd";
import { useExport } from "@pankod/refine-core";
import { ISearch } from "type";

export const TradeList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });
  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "bybit_subscription_id",
        title: "Bybit-subscription Id",
        type: "number",
        width: 160,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "exec_id",
        title: "Exec Id",
        width: 300,
        headerAlign: "center",
      },
      {
        dataIndex: "snapped_at",
        title: "Snapped At",
        width: 200,
        headerAlign: "center",
      },
      {
        dataIndex: "order_id",
        title: "Order Id",
        type: "number",
        width: 320,
        align: "left",
        headerAlign: "center",
      },
      {
        dataIndex: "side",
        title: "Side",
        width: 50,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "symbol",
        title: "Symbol",
        width: 80,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "price",
        title: "Price",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "order_price",
        title: "Order Price",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "order_qty",
        title: "Order Qty",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "order_type",
        title: "Order Type",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "fee_rate",
        title: "Fee Rate",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "exec_price",
        title: "Exec Price",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "exec_type",
        title: "Exec Type",
        width: 100,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "exec_fee",
        title: "Exec Fee",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "exec_value",
        title: "Exec Value",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "leaves_qty",
        title: "Leaves Qty",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "closed_size",
        title: "Closed Size",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "last_liquidity_ind",
        title: "Last Liquidity Ind",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "trade_time",
        title: "Trade Time",
        type: "number",
        width: 120,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "trade_time_ms",
        title: "Trade Time Ms",
        type: "number",
        width: 120,
        align: "center",
        headerAlign: "center",
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          {defaultButtons}
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey="exec_id"
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
